
export class MaiaEchoUnauthorizedException extends Error {
    constructor({ message, stack }: { message: string; stack?: string }) {
        super(message);
        this.name = "MaiaEchoUnauthorizedException";
        if (stack) this.stack = stack;
    }
}
